import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import type { ReactNode } from 'react';

export const AdminRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/failed?code=403" replace />;
  }

  return children;
};
